var alignment_rtlignore_default = {
  "alignLeft": "_4AIZe",
  "textWrapNowrap": "rw83Y",
  "alignRight": "gjl0M",
  "alignCenter": "-O-GI",
  "sizeFullWidth": "QtjFN",
  "renderedInTable": "FTANZ",
  "sizeOriginal": "AdPL9",
  "sizeContent": "u7CaD",
  "sizeSmall": "UjU-T",
  "sizeSmallCenter": "_1HTuj",
  "flex": "MGnHn",
  "LEFT": "_8r3Sy",
  "CENTER": "UhfAP",
  "RIGHT": "ngT-7",
  "AUTO": "iRNRX",
  "JUSTIFY": "gbIEL"
};
export {
  alignment_rtlignore_default as default
};
//# sourceMappingURL=alignment.rtlignore-scss.js.map
